import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
} from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';
import { MenuItem } from '../models/menu-item.model';

export const moduleBlockedGuard: CanActivateChildFn = (childRoute, state) => {
  const store = inject(TokenStorageService);
  const router = inject(Router);
  if (state.url.includes('/401') || state.url.includes('/blocked')) {
    return true;
  }
  const allModules = store.allModulesWithBlocked();
  const declaredModule = findDeclaredModule(childRoute);
  if (declaredModule) {
    const blockedName = findBlockedByLinkName(allModules, declaredModule);
    if (blockedName) {
      return router.createUrlTree(['/user-main/blocked'], {
        queryParams: { module: blockedName },
      });
    }
    return true;
  }

  const blockedModuleName = checkIsBlocked(allModules, state.url);
  if (blockedModuleName) {
    return router.createUrlTree(['/user-main/blocked'], {
      queryParams: { module: blockedModuleName },
    });
  }
  return true;
};
function findDeclaredModule(route: ActivatedRouteSnapshot): string | null {
  for (let r: ActivatedRouteSnapshot | null = route; r; r = r.parent) {
    const m = r.data?.['moduleName'];
    if (m) return m as string;
  }
  return null;
}

function findBlockedByLinkName(
  modules: MenuItem[],
  linkName: string,
  parentName: string | null = null,
  isParentBlocked: boolean = false,
): string | null {
  for (const m of modules) {
    const currentName = parentName || m.name;
    const isBlocked = !!m.blocked || isParentBlocked;
    if (isBlocked && m.linkName === linkName) {
      return currentName;
    }
    if (m.subModules && m.subModules.length > 0) {
      const blockedName = findBlockedByLinkName(
        m.subModules,
        linkName,
        currentName,
        isBlocked,
      );
      if (blockedName) return blockedName;
    }
  }
  return null;
}
function checkIsBlocked(
  modules: MenuItem[],
  url: string,
  parentName: string | null = null,
  isParentBlocked: boolean = false,
): string | null {
  for (const m of modules) {
    const currentName = parentName || m.name;
    const isBlocked = !!m.blocked || isParentBlocked;

    if (isBlocked && m.linkName) {
      if (url.endsWith(`/${m.linkName}`) || url.includes(`/${m.linkName}/`)) {
        return currentName;
      }
    }
    if (m.subModules && m.subModules.length > 0) {
      const blockedName = checkIsBlocked(
        m.subModules,
        url,
        currentName,
        isBlocked,
      );
      if (blockedName) return blockedName;
    }
  }
  return null;
}
